module.exports = __webpack_public_path__ + "static/media/triangle.fe0cd299.svg";